var map = {
	"./caballito.png": "dd66",
	"./carrito.png": "2fea",
	"./covid.png": "abd4",
	"./dona.png": "f524",
	"./freeTime.png": "6c17",
	"./otro.png": "d2ec",
	"./snack.png": "aeb3",
	"./socks.png": "28fb",
	"./trampolin.png": "290b",
	"./tren.png": "15fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e25";